import ListVacationRequests from './views/List.vue'
import CreateEditVacationRequest from './views/CreateEdit.vue'
import GetVacationRequest from './views/Get.vue'

export const VacationRequestRoutes = [
  {
    path: '/vacation-requests',
    name: 'ListVacationRequests',
    component: ListVacationRequests,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'vacation_request:list'
    }
  },
  {
    path: '/vacation-request',
    name: 'CreateVacationRequest',
    component: CreateEditVacationRequest,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'vacation_request:create'
    }
  },
  {
    path: '/vacation-request/:id',
    name: 'UpdateVacationRequest',
    component: CreateEditVacationRequest,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'vacation_request:update'
    }
  },
  {
    path: '/vacation-request/view/:id',
    name: 'GetVacationRequest',
    component: GetVacationRequest,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'vacation_request:get'
    }
  }
]
